import logger from '@eventbrite/client-logger';
import { sdkRequest } from '@eventbrite/http';
import { Dispatch } from 'redux';
import { CheckoutState } from '../state';
import { setIsEbMarketingEmailOptedInAction } from './user';

const fetchEmailPreferences = async (userId: string) => {
    const { attendee_newsletter_email } = await sdkRequest(
        `/user/${userId}/email_preferences/?email_names=attendee_newsletter_email`,
        {
            method: 'GET',
        },
    );
    return attendee_newsletter_email ?? false;
};

export const loadEmailPreferences =
    () =>
    async (
        dispatch: Dispatch<any>,
        getState: () => Pick<CheckoutState, 'user'>,
    ) => {
        const { user } = getState();

        if (!user?.publicId) {
            return;
        }

        try {
            const emailPreference = await fetchEmailPreferences(user.publicId);
            dispatch(setIsEbMarketingEmailOptedInAction(emailPreference));
        } catch (error) {
            logger.error(
                error,
                {
                    action: 'loadEmailPreferences',
                    userId: user.publicId,
                    endpoint: '/user/{userId}/email_preferences',
                },
                {
                    component: 'checkout',
                    feature: 'marketing_opt_in',
                },
            );
        }
    };
